module.exports = __webpack_public_path__ + "img/dealer-fleet.f3363615.png";